import MEDIA_PLANNER_API from 'api/media-planner/v1'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import { GET_DATA } from 'modules/MediaPlanner/store/types'
import { actionSetData } from 'modules/MediaPlanner/store/actions'

function* fetchData({ payload }) {
  const {
    meta: { resolve, reject },
    type,
    method,
    benchmark,
    ...params
  } = payload

  const state = yield select((state) => state['media-planner'])

  try {
    yield put(
      actionSetData({
        [type]: {
          ...state[type],
          data: [],
          loaded: false,
          loading: true,
        },
      }),
    )

    const { response, error } = yield call(MEDIA_PLANNER_API[method], {
      benchmark,
      params,
    })

    if (error) {
      throw error
    }

    if (response?.data) {
      yield put(
        actionSetData({
          [type]: {
            ...state[type],
            data: response.data,
            loaded: true,
            loading: false,
          },
        }),
      )
    }
    resolve()
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    yield put(
      actionSetData({
        [type]: {
          ...state[type],
          data: [],
          loaded: true,
          failed: true,
          loading: false,
        },
      }),
    )
    reject()
  }
}

export default function* Sagas() {
  yield takeEvery(GET_DATA, fetchData)
}
